import { Button, Dialog, DialogActions } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'

import { avSettingEventEmitter, avSettingKeys } from 'helpers/events'

import { DeviceSelector } from '../DeviceSelector/DeviceSelector'

const useStyles = makeStyles(theme =>
    createStyles({
        container: {
            width: '525px',
            minHeight: '400px',
            [theme.breakpoints.down('xs')]: {
                width: 'calc(100vw - 32px)',
            },
            '& .inputSelect': {
                width: 'calc(100% - 35px)',
            },
        },
        button: {
            float: 'right',
        },
        paper: {
            [theme.breakpoints.down('xs')]: {
                margin: '16px',
            },
        },
    })
)

export default function SettingsDialog({}) {
    const classes = useStyles()
    const [selectedTab] = useState(0)

    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(prevOpen => !prevOpen)

    useEffect(() => {
        avSettingEventEmitter.addListener(
            avSettingKeys.OPEN_AV_SETTINGS,
            toggle
        )

        return () => {
            avSettingEventEmitter.removeListener(
                avSettingKeys.OPEN_AV_SETTINGS,
                toggle
            )
        }
    }, [])

    return (
        <Dialog open={open} onClose={toggle} classes={{ paper: classes.paper }}>
            <DeviceSelector
                className={classes.container}
                hidden={selectedTab !== 0}
            />
            <DialogActions>
                <Button className={classes.button} onClick={toggle}>
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    )
}
